
import React from 'react'
import { Checkbox as AntdCheckbox } from 'antd'
import { COLORS } from 'theme'
import styled from 'styled-components'

const StyledCheckbox = styled(AntdCheckbox)`
width: auto;
font-weight: normal;
font-size: 16px;
line-height: 24px;
color: ${COLORS.HEADING};
background-color: white;

.ant-checkbox-input:focus + .ant-checkbox-inner {
  box-shadow: none !important;
}

.ant-checkbox-inner {
  background: white; /* Ensure background is white */
  border-color: #d9d9d9; /* Optional: Ensure border color matches your theme */
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: blue; /* Change inner background to blue when checked */
  border-color: none; /* Ensure border color matches your theme */
}

.ant-checkbox-checked .ant-checkbox-inner::after {
  border: 2px solid White; /* Set tick mark color to black */
  border-top: 0; /* Adjust tick styling */
  border-left: 0; /* Adjust tick styling */
  width: 6px; /* Adjust tick size */
  height: 10px; /* Adjust tick size */
  transform: rotate(45deg) scale(1); /* Ensure correct tick rotation and scaling */
  left: 20%; /* Adjust tick position */
  top: 30%; /* Adjust tick position */
  position: absolute;
  margin-top: -5px;
  margin-left: 1px;
}

${props => props.boxed && `
  padding: 12px 10px;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
`};
`


const Checkboxed = ({ onChange, label, boxed = true, value, ...rest }) => {
  return (
    <StyledCheckbox {...rest} onChange={onChange} boxed={boxed} value={value}>
      {label}
    </StyledCheckbox>
  )
}

export default Checkboxed


